import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ExternalModalViewModel } from '../../view-models/modal/external-modal-view-model';
import { ActivatedRoute } from '@angular/router';
import { IframeComponent } from '../iframe/iframe.component';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { ModalComponentInterface } from '@nts/std/interfaces';

@Component({
    selector: 'nts-external-modal-container',
    templateUrl: 'external-modal-container.component.html',
    styleUrls: ['./external-modal-container.component.scss'],
    standalone: true,
    imports: [
        IframeComponent
    ]
})

export class ExternalModalContainerComponent implements OnInit, ModalComponentInterface {
    viewModel: ExternalModalViewModel;
    inIframe = false;
    iframeLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    @ViewChild('iframe', { static: true }) iframe: ElementRef;

    url: string;
    constructor(private route: ActivatedRoute) {

    }

    ngOnInit(): void {
        if (this.route.snapshot.queryParams['iframe'] != null) {
            this.inIframe = this.route.snapshot.queryParams['iframe'] === 'true';
        }
        this.viewModel.initialize(async (iframeUrl: string) => {
            this.url = iframeUrl;

            // Necessario per dare tempo al componente di caricarsi
            // non compromette blocchi ui
            await firstValueFrom(this.iframeLoaded.pipe(
                filter(x => x == true)
            ), {
                defaultValue: null
            });

            return this.iframe.nativeElement.contentWindow;
        });
    }
}
